var map = {
	"./back-icon.svg": "0f53",
	"./banner-left.svg": "d073",
	"./banner-right.svg": "dad3",
	"./close.svg": "864a",
	"./icon-home.svg": "4b9b",
	"./jigouruzhu-1.svg": "e291",
	"./jigouruzhu-2.svg": "dae6",
	"./play-icon.svg": "df82",
	"./play.svg": "4c1a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "23f1";